import { SVGAssets } from '@business/assets/vectors';
import { useState } from 'react';
import { Button } from '../Button';
import LasagnaChatBot from './LasagnaChatBot';

const ChatBotButton = () => {
  const [isOpenChatBot, setIsOpenChatBot] = useState<boolean>(false);
  const [isMinimizedChatBot, setIsMinimizedChatBot] = useState<boolean>(false);
  return (
    <div>
      {!isOpenChatBot ? (
        <Button
          btnStyle="link"
          className="chat-icon notes-icon-chat flex justify-center items-center cursor-pointer !mt-5 !bg-[var(--theme-tertiary-color)]"
          onClick={() => {
            setIsOpenChatBot(true);
          }}>
          <SVGAssets.ChatBotIcon className="w-28" />
        </Button>
      ) : (
        <LasagnaChatBot
          {...{
            setIsOpenChatBot,
            isMinimizedChatBot,
            setIsMinimizedChatBot
          }}
        />
      )}
    </div>
  );
};

export default ChatBotButton;
